import * as React from 'react';
import './_CardProgress.scss';
import { Done, Tooltip } from 'kui';
import { ICardCell } from '../../types';
import { CLASS_MY_WORK_CARD } from '../../../constants';
import { DONE_TITLE } from '../../../../../../../const';
import { AnalyzeRender } from '../../../../../helpers/memoizeHelper';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`myWork CardProgress`) : null;

export function CardProgress ({
    card
}: ICardCell) {
    if (analyzeRender) analyzeRender.call(card.cardId);
    const className = CLASS_MY_WORK_CARD + '__progress';
    return (
        <div className={className}>
            <Tooltip
                direction={'up'}
                value={card.processingPercent + '% ' + DONE_TITLE}
            >
                <Done
                    percent={card.processingPercent}
                    size={'small'}
                    titleDone={DONE_TITLE}
                    titlePercent={null}
                />
            </Tooltip>
        </div>
    );
};
